"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const QuestelServicesClient_1 = require("../QuestelServicesClient");
const CommonModule_1 = __importDefault(require("../store/CommonModule"));
const vuex_module_decorators_1 = require("vuex-module-decorators");
const SettingsHelper_1 = require("./SettingsHelper");
const msal_browser_1 = require("@azure/msal-browser");
const msal_common_1 = require("@azure/msal-common");
class MsalService {
    constructor(vuexStore) {
        // Add here scopes for id token to be used at MS Identity Platform endpoints.
        this.loginRequest = {
            scopes: ['User.Read'],
        };
        this.client = new QuestelServicesClient_1.QuestelServicesClient(vuexStore, '');
        this.commonState = vuex_module_decorators_1.getModule(CommonModule_1.default, vuexStore);
    }
    get myMSALObj() {
        return this._myMSALObj;
    }
    ensureSettings(baseRoute = "/api") {
        return __awaiter(this, void 0, void 0, function* () {
            return SettingsHelper_1.SettingsHelper.getMsalAuthSettings(baseRoute).then((result) => {
                let msalConfig = {
                    auth: result,
                    cache: {
                        cacheLocation: 'localStorage',
                        storeAuthStateInCookie: false,
                    },
                };
                this._myMSALObj = new msal_browser_1.PublicClientApplication(msalConfig);
            });
        });
    }
    getSilentRequest() {
        let accountObj = this.getAccountInfo();
        let request = this.loginRequest;
        request.account = accountObj;
        return { request, accountObj };
    }
    authenticateWithTokenResponse(accountObj, tokenResponse, productName) {
        return __awaiter(this, void 0, void 0, function* () {
            if (accountObj == null) {
                throw new Error('Account info not found.');
            }
            const username = accountObj.username;
            let authRequest = {
                username: username,
                idToken: tokenResponse && tokenResponse.idToken,
                accessToken: tokenResponse && tokenResponse.accessToken,
                product: productName,
            };
            let currentAppSettings = this.commonState.getApplicationSettings;
            if (typeof (currentAppSettings) === 'undefined' || currentAppSettings === null) {
                return this.client.postJson(`${this.commonState.authenticationUrl}/api/serviceuser/authenticate-ad`, authRequest);
            }
            else {
                return this.client.postJson(`${currentAppSettings.ApplicationUrl + currentAppSettings.ActiveDirectoryLoginPath}`, authRequest);
            }
        });
    }
    getAccount(baseRoute = "/api") {
        return __awaiter(this, void 0, void 0, function* () {
            return this.ensureSettings(baseRoute).then(() => {
                return this.getAccountInfo();
            });
        });
    }
    getAccountInfo() {
        const currentAccounts = this.myMSALObj.getAllAccounts();
        let accountObj = null;
        if (currentAccounts !== null) {
            // No user signed in
            if (currentAccounts.length > 1) {
                // More than one user signed in, find desired user with getAccountByUsername(username)
                currentAccounts.forEach((element) => {
                    if (element.username.endsWith('questel.com')) {
                        accountObj = element;
                    }
                });
            }
            else {
                accountObj = currentAccounts[0];
            }
        }
        return accountObj;
    }
    signOut(baseRoute = "/api") {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.ensureSettings(baseRoute);
            let account = yield this.getAccount();
            if (account) {
                let request = {
                    account: account,
                    postLogoutRedirectUri: this.commonState.postADLoginRedirectUrl
                };
                let currentAppSettings = this.commonState.getApplicationSettings;
                if (typeof (currentAppSettings) !== 'undefined' && currentAppSettings !== null) {
                    try {
                        yield this.client.getJson(`${currentAppSettings.ApplicationUrl + currentAppSettings.LogoutPath}`);
                    }
                    catch (error) {
                        console.log(error);
                    }
                }
                yield this.commonState.deleteUserSession();
                yield this.myMSALObj.logoutRedirect(request);
            }
        });
    }
    signIn(productName, state, baseRoute = "/api") {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.ensureSettings(baseRoute);
            let { request, accountObj } = this.getSilentRequest();
            let redirectRequest = Object.assign(Object.assign({}, this.loginRequest), { state: state });
            if (!accountObj) {
                return this.myMSALObj.loginRedirect(redirectRequest);
            }
            return this.myMSALObj
                .acquireTokenSilent(request)
                .then(tokenResponse => {
                return this.authenticateWithTokenResponse(accountObj, tokenResponse, productName);
            })
                .catch((error) => {
                // If error is an InteractionRequiredAuthError, fallback to acquiring a token via redirect.
                // Based on https://docs.microsoft.com/en-us/azure/active-directory/develop/msal-handling-exceptions?tabs=javascript#javascript-1
                if (error.name === 'InteractionRequiredAuthError') {
                    return this.myMSALObj.loginRedirect(redirectRequest);
                }
                else {
                    throw error;
                }
            });
        });
    }
    attemptCompleteLoginSilent(productName, baseRoute = "/api") {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.ensureSettings(baseRoute);
            let { request, accountObj } = this.getSilentRequest();
            let tokenResponse = yield this.myMSALObj.acquireTokenSilent(request);
            return this.authenticateWithTokenResponse(accountObj, tokenResponse, productName);
        });
    }
    completeLogin(productName, baseRoute = "/api") {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.ensureSettings(baseRoute);
            let tokenResponse = yield this.myMSALObj.handleRedirectPromise();
            let accountObj = this.getAccountInfo();
            return this.authenticateWithTokenResponse(accountObj, tokenResponse, productName);
        });
    }
    acquireADToken(productName, state, baseRoute = "/api") {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.ensureSettings(baseRoute);
            try {
                const redirectResponse = yield this.myMSALObj.handleRedirectPromise();
                let { request } = this.getSilentRequest();
                request.state = state;
                if (redirectResponse == null) {
                    return this.myMSALObj.loginRedirect(request);
                }
                if (!request.account) {
                    return this.myMSALObj.loginRedirect(request);
                }
                else {
                    yield this.setAccessToken(request, redirectResponse, productName);
                    const state = redirectResponse.state != null ? JSON.parse(redirectResponse.state) : undefined;
                    if (state) {
                        return state;
                    }
                }
            }
            catch (error) {
                if (error.errorCode === 'interaction_required' || (error instanceof msal_common_1.InteractionRequiredAuthError)) {
                    console.warn("Silent token acquisition fails. Acquiring token using redirect");
                    // fallback to interaction when silent call fails
                    let { request } = this.getSilentRequest();
                    return yield this.myMSALObj.acquireTokenRedirect(request);
                }
                else {
                    throw error;
                }
            }
        });
    }
    setAccessToken(request, redirectResponse, productName) {
        return __awaiter(this, void 0, void 0, function* () {
            if (redirectResponse != null) {
                const authResult = yield this.authenticateWithTokenResponse(request.account, redirectResponse, productName);
                yield this.commonState.setAuthToken(authResult.Data);
            }
            else {
                const result = yield this.myMSALObj.acquireTokenSilent(request);
                const authResult = yield this.authenticateWithTokenResponse(request.account, result, productName);
                yield this.commonState.setAuthToken(authResult.Data);
            }
        });
    }
}
exports.MsalService = MsalService;
// This function is used by Thor and Authentication service vue apps. Make sure communicate with those teams any update on it.
function checkForAzureAdCodeUrl(to) {
    let codeQuery = { redirect: to.fullPath };
    let query = to.redirectedFrom != null && to.redirectedFrom.startsWith('/code') ? to.redirectedFrom : to.fullPath != null && to.fullPath.startsWith('/code') ? to.fullPath : null;
    if (query != null) {
        query = query.substring(1);
        let querySpit = query.split('&');
        querySpit.forEach((element) => {
            let keyValue = element.split('=');
            codeQuery[keyValue[0]] = decodeURIComponent(keyValue[1]);
        });
    }
    return codeQuery;
}
exports.checkForAzureAdCodeUrl = checkForAzureAdCodeUrl;
//# sourceMappingURL=MsalService.js.map